import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":((_vm.$t('Rate')) + " (%)"),"outlined":"","type":"number","hide-details":"auto"},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }